import React from 'react';

import { Container } from '@pray/shared/components/layout';
import Background from '@pray/shared/components/ui/Background/Background';
import { cn } from '@pray/shared/utils/styles';

import type { CheckoutProps } from '../types';

import styles from './CheckoutRoot.module.scss';

export default function Checkout({ children, className, eventProps }: CheckoutProps) {
  return (
    <Background {...eventProps}>
      <div className={cn(styles.checkout, className)}>
        <Container className={styles.container}>{children}</Container>
      </div>
    </Background>
  );
}
